<template>
  <aside
    v-if="isVisible"
    class="w-full lg:w-[480px] bg-card rounded-2xl shadow-sm border border-border flex flex-col overflow-hidden animate-in slide-in-from-right-10 duration-500 h-full lg:h-auto"
  >
    <!-- Sidebar Header -->
    <div
      class="h-16 border-b border-border flex items-center justify-between px-6 shrink-0"
    >
      <h2 class="font-bold text-[20px] text-foreground truncate pr-4">
        Summary & Key Points
      </h2>
      <button
        @click="$emit('close')"
        class="p-1 hover:bg-muted/50 rounded-md transition-colors"
      >
        <X class="w-5 h-5 text-muted-foreground" />
      </button>
    </div>

    <div class="p-4 lg:p-6 flex-1 overflow-y-auto space-y-8">
      <!-- Goal Overview -->
      <section>
        <h4 class="text-[16px] font-bold text-foreground mb-2">Summary</h4>
        <p class="text-[16px] text-muted-foreground leading-relaxed">
          {{
            enrichedTopic?.description || "No summary provided for this topic."
          }}
        </p>
      </section>

      <section>
        <h4 class="text-[16px] font-bold text-foreground mb-2">Key Points</h4>
        <ul class="space-y-4">
          <li
            v-for="(point, index) in enrichedTopic?.key_takeaway_from_topic ||
            []"
            :key="index"
            class="flex gap-3 items-start"
          >
            <span
              class="w-2 h-2 rounded-full bg-muted-foreground/30 mt-1.5 shrink-0"
            ></span>
            <p class="text-sm text-foreground leading-snug">
              {{ point }}
            </p>
          </li>
        </ul>
        <p
          v-if="!enrichedTopic?.key_takeaway_from_topic?.length"
          class="text-sm text-muted-foreground italic"
        >
          No key points listed for this topic.
        </p>
      </section>
    </div>
  </aside>
</template>

<script>
import { X } from "lucide-vue-next";

export default {
  name: "SummaryComponent",
  components: {
    X,
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    goal: {
      type: Object,
      default: () => ({}),
    },
    modules: {
      type: Array,
      default: () => [],
    },
    selectedTopic: {
      type: Object,
      default: () => null,
    },
  },
  emits: ["close"],
  computed: {
    enrichedTopic() {
      if (!this.selectedTopic || !this.modules) return this.selectedTopic;

      // The selectedTopic comes from tasks (sidebar), but we need data from learning_tree (modules prop)
      // We find the matching topic in the learning_tree by name
      for (const module of this.modules) {
        if (module.topics) {
          const found = module.topics.find(
            (t) => t.name === this.selectedTopic.name,
          );
          if (found) return found;
        }
      }
      return this.selectedTopic;
    },
  },
};
</script>

<style scoped>
.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
